<!-- DeleteCouponUserForm.vue -->
 <!-- DeleteCouponUserForm.vue -->
<script setup>
import { computed } from "vue";
import { useCouponUserStore } from "@/stores/useCouponUserStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  couponUser: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useCouponUserStore();

// ID do vínculo (tolera PascalCase por robustez)
const couponUserId = computed(() => {
  return props.couponUser?.couponUserId || props.couponUser?.CouponUserId || null;
});

// Rótulo descritivo para a mensagem de confirmação.
// Preferimos algo como "cupom 'LTR20' atribuído a fulano"; se faltar dado,
// cai num fallback enxuto pelo ID.
const linkLabel = computed(() => {
  const cu = props.couponUser;
  if (!cu) return "";

  const code = cu.couponCode || cu.CouponCode || `#${cu.couponId ?? cu.CouponId ?? ""}`;
  const user = cu.userName || cu.UserName || `#${cu.userId ?? cu.UserId ?? ""}`;

  return `cupom "${code}" atribuído a ${user}`;
});

const messageTitle = computed(() => {
  const label = linkLabel.value;
  if (!label) return "Tem certeza que deseja apagar este vínculo?";
  return `Tem certeza que deseja apagar o vínculo: ${label}?`;
});

function buildDeleteError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir o vínculo."
  );
}

async function onConfirmDelete() {
  try {
    if (!couponUserId.value) {
      throw new Error("ID do vínculo não encontrado para exclusão.");
    }

    await store.deleteCouponUserById(couponUserId.value);

    emit("notify", {
      type: "success",
      message: "Vínculo apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    // Padrão: throw para o modal genérico parar o loading
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Vínculo de Cupom"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-lo, o usuário perde a elegibilidade manual para este cupom. Como alternativa, considere revogar o vínculo (preservando o histórico). Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>